import React from 'react';
import { Stepper, Step, StepLabel, Typography } from '@material-ui/core';

export default ({ activeStep }) => {
    const steps = ["Sign In", "Select Group", "Form Builder", "Create"];
    return (
        <Stepper activeStep={activeStep} style={{ marginBottom: 50 }}>
            {steps.map((label) => {
                const stepProps = {};
                const labelProps = {};
                return (
                    <Step key={label} {...stepProps}>
                        <StepLabel {...labelProps}>
                            <Typography component='span' style={{ fontWeight: 600, marginRight: 5 }}>
                                {label}
                            </Typography>
                        </StepLabel>
                    </Step>
                );
            })}
        </Stepper>
    )
}


// WEBPACK FOOTER //
// ./src/containers/widget/components/Stepper.js